class BritishColumbiaObstetricalFileAlcohol {
    public DrankAlcoholThreeMonthsBeforePregnancy?: boolean;
    public DrinksAlcoholDuringPregnancy?: boolean;
    public DrinksPerWeekThreeMonthsBeforePregnancy?: string;
    public DrinksPerWeekDuringPregnancy?: string;
    public GreaterOrEqualFourDrinksAtOneTimeThreeMonthsBeforePregnancy?: boolean;
    public GreaterOrEqualFourDrinksAtOneTimeDuringPregnancy?: boolean;
    public HasQuitAlcohol?: boolean;
    public QuitAlcoholDate: Date;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileAlcohol>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFileAlcohol };
